import { formatINR } from '../../../shared/utils/formatters';
import React, { useEffect } from 'react'
import { Modal, Form, Input, InputNumber, Space, Button } from 'antd'
import type { Payment } from '../types/payment.types'

interface RefundModalProps {
    open: boolean
    onCancel: () => void
    onFinish: (values: any) => void
    payment: Payment | null
}

export const RefundModal: React.FC<RefundModalProps> = ({ open, onCancel, onFinish, payment }) => {
    const [form] = Form.useForm()

    useEffect(() => {
        if (open && payment) {
            form.setFieldsValue({
                refundAmount: payment.amount
            })
        } else {
            form.resetFields()
        }
    }, [open, payment, form])

    const handleSubmit = (values: any) => {
        onFinish(values)
        form.resetFields()
    }

    if (!payment) return null

    return (
        <Modal
            title="Process Refund"
            open={open}
            onCancel={onCancel}
            footer={null}
        >
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Form.Item label="Payment ID">
                    <Input value={payment.id} disabled />
                </Form.Item>
                <Form.Item label="Original Amount">
                    <Input value={formatINR(payment.amount.toLocaleString())} disabled />
                </Form.Item>
                <Form.Item
                    label="Refund Amount"
                    name="refundAmount"
                    rules={[{ required: true, message: 'Please enter refund amount' }]}
                >
                    <InputNumber
                        min={1}
                        max={payment.amount}
                        style={{ width: '100%' }}
                        prefix="₹"
                    />
                </Form.Item>
                <Form.Item
                    label="Reason"
                    name="reason"
                    rules={[{ required: true, message: 'Please provide a reason' }]}
                >
                    <Input.TextArea rows={3} placeholder="Reason for refund..." />
                </Form.Item>
                <Form.Item>
                    <Space>
                        <Button type="primary" danger htmlType="submit">
                            Process Refund
                        </Button>
                        <Button onClick={onCancel}>Cancel</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    )
}
